module.exports = __webpack_public_path__ + "cancellara-dist/img/servizi_business_1.89fd7748.png";